export default __webpack_public_path__ + "static/media/notification-red.2afd7c21.svg";